import { SKAN_UNIFIED_TABLE } from '../../constants/analytics/contexts';
import { UNIFIED_REPORT_DRILLDOWN } from '../../constants/flipperFlags';
import { DrilldownMapperService } from '../DrilldownMapperService';

type UnifiedAdsState = {
  selectedColumns?: any[];
  isMigratedToDrilldown?: boolean;
  [SKAN_UNIFIED_TABLE]?: {
    granularity?: string;
    activeMode?: string;
    query: {
      dimensions: string[];
      granularity?: string;
    };
  };
};

interface FlipperFlagProvider {
  get(flag: string): Promise<boolean>;
}

export class UnifiedAdsDrilldownMigrator<
  S extends UnifiedAdsState = UnifiedAdsState,
  F extends FlipperFlagProvider = FlipperFlagProvider,
> {
  constructor(
    private flipperFlagProvider: F,
    private drilldownMapperServiceClass: typeof DrilldownMapperService = DrilldownMapperService
  ) {}

  private async buildDrilldownMapperService() {
    const isDrilldownEnabled = await this.flipperFlagProvider.get(UNIFIED_REPORT_DRILLDOWN);

    return new this.drilldownMapperServiceClass(isDrilldownEnabled);
  }

  async migrate(unifiedAdsState: S) {
    const drilldownMapperService = await this.buildDrilldownMapperService();

    if (!drilldownMapperService.needsMigration(unifiedAdsState)) {
      return;
    }

    drilldownMapperService.setAsMigrated(unifiedAdsState);

    const table = unifiedAdsState[SKAN_UNIFIED_TABLE];

    if (!table) {
      return;
    }

    drilldownMapperService.setActiveMode(table);

    const drilldownMapper = drilldownMapperService.buildDrilldownMapper(
      unifiedAdsState.selectedColumns,
      table.granularity,
      table.query.dimensions
    );

    if (drilldownMapper.needsUpdate()) {
      unifiedAdsState.selectedColumns = drilldownMapper.getSelectedColumns();
      table.granularity = drilldownMapper.getGranularity();
      table.query.granularity = table.granularity;
      table.query.dimensions = drilldownMapper.getDimensions();
    }
  }
}
